export default __webpack_public_path__ + "static/media/stop-button-white-circle-solid.a5d2a494.svg";